import dayjs from 'dayjs';
import { DateRange } from '../../DateRangePicker';

export const getPreviousRange = (range: DateRange): DateRange => {
    const start = dayjs(range.startDate);
    const end = dayjs(range.endDate);
    const diffDays = end.diff(start, 'day');
    const prevEnd = start;
    const prevStart = start.subtract(diffDays + 1, 'day');
    return { startDate: prevStart.toDate(), endDate: prevEnd.toDate() };
};
